<div class="container-fluid">
  <div class="row">
    <div class="col-12" *ngIf="ctrlData.currentActive==1">
      <list-permit [ctrlData]="ctrlData"></list-permit>
    </div>

    <div class="col-12" *ngIf="ctrlData.currentActive==2">
      <permit-viewer [ctrlData]="ctrlData"></permit-viewer>
    </div>

    <div class="col-12" *ngIf="ctrlData.currentActive==3">
      <correspondence [ctrlData]="ctrlData"></correspondence>
    </div>
  </div>

  <div class="col-12" *ngIf="ctrlData.currentActive==4">
    <printing [ctrlData]="ctrlData"></printing>
  </div>

</div>

